export type EventMap = {
    [key: string]: any;
};

export type EventBusCallback<T extends EventMap, K extends keyof T> = (arg: T[K]) => void;

export interface EventBus<T extends EventMap> {
    subscribers: { [key in keyof T]?: EventBusCallback<T, key>[] };
    subscribe: <K extends keyof T>(eventType: K, callback: EventBusCallback<T,K>) => () => void;
    emit: <K extends keyof T>(eventType: K, arg?: T[K]) => void;
    clear: () => void;
}


export function createEventBus<T extends EventMap>(): EventBus<T> {
    return {
        subscribers: {},
        subscribe(eventType, callback) {
            if (!this.subscribers[eventType]) {
                this.subscribers[eventType] = [];
            }
            this.subscribers[eventType]?.push(callback);
            return () => {
                const index = this.subscribers[eventType]?.indexOf(callback);
                if (index !== undefined && index !== -1) {
                    this.subscribers[eventType]?.splice(index, 1);
                }
            };
        },
        emit(eventType, ...args) {
            const callbacks = this.subscribers[eventType] || [];
            callbacks.forEach((callback) => (callback as (a: any) => void)(...args));
        },
        clear() {
            this.subscribers = {};
        },
    };
}
